// extracted by mini-css-extract-plugin
export var container = "_gq-1";
export var cornerButtonContainer = "_gq-6";
export var disabled = "_gq-2";
export var dragActive = "_gq-3";
export var fileContainer = "_gq-5";
export var hiddenInput = "_gq-4";
export var widthContainer = "_gq-0";